const state = {
    notificationMessage: null
}

const mutations = {
    SET_NOTIFICATION_MESSAGE(state, value) {
        state.notificationMessage = value
    }
}

const actions = {
    setNotificationMessage({commit}, value) {
        commit('SET_NOTIFICATION_MESSAGE', value);
        let duration = 5000;
        if (typeof value === 'object' && value?.duration) duration = value?.duration
        setTimeout(() => {
            commit('SET_NOTIFICATION_MESSAGE', null);
        }, duration)
    }
}

const getters = {};

const notifications = {state, mutations, actions, getters};
export default notifications;